import { useState } from 'react';
import { Link, useLocation } from 'react-router';

import { Button } from '@/components/ui/Button';
import { analyticsAvailable, getConsent, setConsent, trackPageView } from '@/lib/analytics';

/**
 * Asks before Google Analytics loads. Shown once, on NeonCarts' own pages only:
 * a merchant's shop never runs our analytics, so it never asks.
 */
export function ConsentBanner() {
  const { pathname } = useLocation();
  const [answered, setAnswered] = useState(() => getConsent() !== null);

  if (answered || !analyticsAvailable(window.location.hostname, pathname)) return null;

  const choose = (accept: boolean) => {
    setConsent(accept ? 'granted' : 'denied');
    // The page they accepted on counts as the first page of the visit.
    if (accept) trackPageView(pathname);
    setAnswered(true);
  };

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-white px-4 py-4 shadow-card sm:inset-x-auto sm:bottom-4 sm:right-4 sm:max-w-md sm:rounded-2xl sm:border"
    >
      <p className="text-sm leading-relaxed text-ink-soft">
        We use Google Analytics cookies to understand how people use NeonCarts and improve it.
        No advertising cookies. See our{' '}
        <Link to="/legal" className="font-medium text-brand-600 underline">
          policies
        </Link>
        .
      </p>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={() => choose(true)}>
          Accept
        </Button>
        <Button size="sm" variant="outline" onClick={() => choose(false)}>
          Decline
        </Button>
      </div>
    </div>
  );
}
